export const PRIMARY_COLOR = '#01B9A1';
